import { Settings } from '../../Settings';
export class OptimalDelayCalculator {
    windowLength = 20; // Store last 10 arrival times
    chunkArrivalTimesMillis = [];
    chunkCounter = 0;
    ADDITIONAL_DELAY_MS = Settings.additionalSafetyDelayMillis;
    reset() {
        this.chunkArrivalTimesMillis = [];
        this.chunkCounter = 0;
    }
    addToQueue(time) {
        this.chunkArrivalTimesMillis.push(time);
        if (this.chunkArrivalTimesMillis.length > this.windowLength) {
            this.chunkArrivalTimesMillis.shift(); // Remove oldest element
        }
    }
    addChunkArrivalTimeMillis(chunkArrivalTimeMillis) {
        this.addToQueue(chunkArrivalTimeMillis);
        this.chunkCounter++;
    }
    addChunkArrivalTimesMillis(chunkArrivalTimesMillis) {
        for (const chunkArrivalTimeMillis of chunkArrivalTimesMillis) {
            this.addChunkArrivalTimeMillis(chunkArrivalTimeMillis);
        }
    }
    /*
     * @return the maximum chunk arrival interval in the last windowLength chunks
     */
    calculateOptimalDelayMillis() {
        if (this.chunkArrivalTimesMillis.length < this.windowLength) {
            return undefined;
        }
        let maxInterval = 0;
        const intervals = [];
        for (let i = 1; i < this.chunkArrivalTimesMillis.length; i++) {
            const interval = this.chunkArrivalTimesMillis[i] -
                this.chunkArrivalTimesMillis[i - 1];
            intervals.push(interval);
            maxInterval = Math.max(maxInterval, interval);
        }
        return maxInterval + this.ADDITIONAL_DELAY_MS;
    }
}
/*

Video element buffer

Chunks are produced approximately every 100ms
Chunks arrive every 100ms + variable network delay

Initial situation:

_________       _____________________________________________
^                                   ^                       ^
|                                   |                       |
|                                   |                       |
playbackPosition = null          seekPosition = 29850ms    endOfBuffer = 30000ms


Chunk arrival times:
(these are absolute times in ms, not video time)

[100, 230, 330, 480, 580, 680, 780, 880, 980, 1080]

Max chunk arrival interval: 150ms

*/
